import commonJSON from "../../../config/common/en.json";
import { namespaces } from "../../../lib/localisation/config";

export const ENConfig = {
  common: commonJSON,
} as const satisfies Record<(typeof namespaces)[number], unknown>;
